import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox } from './FieldLayoutBox'
import { FieldValueFormatter, FieldValueParser, FieldValueConverters } from './FieldValueConverters'
import { Input } from 'reactstrap'
import { BooleanFormatter } from './Formatters/BooleanFormatter'

class CheckBoxClass extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    readonlyTrueValue: pt.any,
    readonlyFalseValue: pt.any
  })

  static defaultProps = {
    readonlyTrueValue: 'Yes',
    readonlyFalseValue: 'No'
  }

  render () {
    const { readonlyTrueValue, readonlyFalseValue, ...rest } = this.props
    return (
      <FieldLayoutBox {...rest} isCheckBox={true}>
        {({ showError, value, onChange, name, placeHolder, loading, readonly }) => {
          if (readonly) {
            var formattedValue = BooleanFormatter({ trueValue: readonlyTrueValue, falseValue: readonlyFalseValue, value: value })
            return <Input type='text' readOnly name={`view${name}`} id={`view${name}`} value={formattedValue} />
          } else {
            return <Input type='checkbox' disabled={loading} invalid={showError} name={`text${name}`} id={`text${name}`} onChange={onChange} checked={value} />
          }
        }}
      </FieldLayoutBox>
    )
  }
};

export const CheckBox = ({ parse, format, fieldType = FieldValueConverters.Boolean, ...rest }) => { return <Field parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={CheckBoxClass} /> } // eslint-disable-line
export default CheckBox
